import React from "react";
import "./product-card.css";
import { useNavigate } from "react-router-dom";

const Product_card = ({ id, image, price, product_name, description }) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    navigate(`/product-description/${id}`);
  };

  return (
    <section className="Product_card">
    
      <div className="img_div" onClick={handleViewDetails}>
        <img className="prod_img" src={image} alt={product_name} />
      </div>

      <div className="prd_details">
        {/* NAME */}
        <h3 className="prd_name" onClick={handleViewDetails}>
          {product_name}
        </h3>

        {/* PRICE */}
        <div className="price_box">
          {/* <span className="price_label">Price</span> */}

          <span className="modelno">₹{price}</span>
        </div>

        {/* DESCRIPTION */}
        {description && (
          <div
            className="product_description"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        )}
      </div>
    </section>
  );
};

export default Product_card;
